import * as types from './planningActionTypes.js';

export const setPlanningData = (data) => ({ type: types.SET_PLANNINGDATA, data: data });
export const setPlanningDate = (date) => ({ type: types.SET_PLANNINGDATE, date: date });
export const setCreateEditDrawerOpen = (createEditDrawerOpen) => ({ type: types.SET_CREATEEDITDRAWEROPEN, createEditDrawerOpen: createEditDrawerOpen });